var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrowD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down_arrow_d",
    transform: "translate(-864 378) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3046",
    "data-name": "\\u9577\\u65B9\\u5F62 3046",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(354 864)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron_left_FILL1_wght400_GRAD0_opsz48",
    d: "M21.978,23.856,16,17.878,21.978,11.9l1.067,1.067-4.911,4.911,4.911,4.911Z",
    transform: "translate(346.478 858.122)",
    fill: "#666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowD);
export default __webpack_public_path__ + "static/media/down_arrow_d.69263aef2a84935c53cdaa02dbdc7285.svg";
export { ForwardRef as ReactComponent };